/* eslint-disable no-constant-condition */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-shadow */
// should go through these at some point
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/indent */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
import React, { FC, useState, useEffect } from 'react'
import Draggable from 'react-draggable'
import { Button as BootBtn, Form } from 'react-bootstrap'
import { inject, observer } from 'mobx-react'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import DatePicker from 'react-datepicker'
import {
  Divider,
  ListItemText,
  ListItemIcon,
  Paper,
  List,
  ListItem,
  MenuList,
  Collapse,
} from '@material-ui/core'
import {
  FaHotjar,
  FaBullhorn,
  FaUserSlash,
  FaTrashAlt,
  FaTelegramPlane,
  FaTimes,
  FaRegCircle,
  FaCheckCircle,
  FaBullseye,
  FaBellSlash,
} from 'react-icons/fa'
import moment from 'moment'
import _ from 'lodash'
import { ExpandLess, ExpandMore } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import API from '@aws-amplify/api'
import { Search as SearchStore } from '../../../stores/search'
import { Prospects as ProspectsStore } from '../../../stores/prospects'
import { ranks } from '../../../utils/constants'
import './Common.scss'

interface Props extends RouteComponentProps {
  search?: SearchStore
  leadsToBeUpdated: any
  prospects?: ProspectsStore
  setIsLoading: any
  setOpenActions: any
  openActions: any
  isEmailsOnly?: boolean
  isLoading?: boolean
}

const position = { x: 700, y: 50 }
const isWeekday = (date: Date): boolean => {
  const day = date.getDay()
  return day !== 0 && day !== 6
}

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  nestedSecondLevel: {
    paddingLeft: theme.spacing(6),
  },
  nestedThirdLevel: {
    paddingLeft: theme.spacing(8),
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  selectOrder: {
    '& .MuiSelect-root': {
      maxWidth: 160,
      fontSize: 14,
      padding: '5px 10px 5px 35px',
      height: '15px',
      borderRadius: '0.25rem',
      minWidth: 220,
      display: 'flex',
      alignItems: 'center',
    },
    '& legend': {
      display: 'none',
    },
    '& fieldset': {
      height: 25,
      top: 1,
    },
  },
  formControl: {
    minWidth: 120,
  },
}))

const BulkLeadActions: FC<Props> = ({
  search,
  prospects,
  leadsToBeUpdated,
  setIsLoading,
  setOpenActions,
  openActions,
  isEmailsOnly,
  isLoading,
}): JSX.Element => {
  const classes = useStyles()

  const [openAssign, setOpenAssign] = useState(false)
  const [openAssignManeuver, setOpenAssignManeuver] = useState('')
  const [openAssignMission, setOpenAssignMission] = useState('')
  const [openRank, setOpenRank] = useState(false)
  const [openAssignRank, setOpenAssignRank] = useState('')
  const [currentAction, setCurrentAction] = useState('')
  const [deleteType, setDeleteType] = useState('')
  // const anchorActionsRef = useRef<HTMLButtonElement>(null)

  const [maneuverList, setManeuverList] = useState<any[]>()
  const [startDate, setStartDate] = useState(moment(new Date()).format('MM/DD/YYYY'))

  const handleDeleteTypeChange = (value): void => {
    if (deleteType === value) {
      setDeleteType('')
    } else {
      setDeleteType(value)
    }
  }

  const cleanManeuver = (): void => {
    setOpenAssignManeuver('')
    setOpenAssignMission('')
    setOpenAssign(false)
  }
  const handleActionsClose = (): void => {
    setCurrentAction('')
    cleanManeuver()
    setOpenActions(false)
  }
  const handleStartDateChange = (value): void => {
    setStartDate(moment(value).format('MM/DD/YYYY'))
  }

  const handleClickAssign = (): void => {
    setOpenAssign(!openAssign)
    setCurrentAction('')
  }

  const handleClickRank = (): void => {
    setOpenRank(!openRank)
    setCurrentAction('')
  }

  const handleClickAssignRank = (value): void => {
    setOpenAssignRank(value)
  }

  const handleClickAssignManeuver = (value): void => {
    if (openAssignManeuver === value) {
      setOpenAssignManeuver('')
    } else {
      setOpenAssignManeuver(value)
    }
    setOpenAssignMission('')
  }

  const handleClickAssignMission = (value): void => {
    if (openAssignMission === value) {
      setOpenAssignMission('')
    } else {
      setOpenAssignMission(value)
    }
  }

  const excutePromises = async promises => {
    try {
      await Promise.all(promises)
    } catch (e) {
      console.error(e)
    }
  }

  // As we are not getting Whole data from reporting section we need to fetch leads
  // TODO: We can created an endpoint to get all leads data at a time
  // eslint-disable-next-line @typescript-eslint/require-await
  const getLeadsDataToUpdate = async () => {
    if (isEmailsOnly) {
      const responses: any = []

      await Promise.all(
        leadsToBeUpdated?.map(async item => {
          try {
            const res = await API.get('mav-outlook-api', `/leads/${item}`, {})
            responses.push(res)
          } catch (error) {
            console.log(error)
          }
        }),
      )
      return Promise.resolve(responses)
    }
    return Promise.resolve(leadsToBeUpdated)
  }

  const onAssignManeuver = async (): Promise<void> => {
    const ManeuverMappings = {
      'Rev-Up': 'firstTouch',
      Engaged: 'followUp',
      'Re-Engage': 'nurture',
    }

    setIsLoading(true)
    const selectedItems: any = await getLeadsDataToUpdate()
    const promises: any[] = []
    const dataToUpdate = {}

    for (let count = 0; count < selectedItems.length / 25; count += 1) {
      const payload: any[] = []
      const temp = (count + 1) * 25 > selectedItems.length ? selectedItems.length : (count + 1) * 25
      for (let i = count * 25; i < temp; i += 1) {
        const localManeuver = ManeuverMappings[openAssignManeuver]

        const payloadBody = {
          status: 'emailScheduled',
          maneuver: localManeuver,
          sendDate: startDate,
          title: selectedItems[i].title,
          company: selectedItems[i].company,
          industry: selectedItems[i].industry,
          missionNumber: parseInt(openAssignMission.slice(-1), 10),
        }
        dataToUpdate[selectedItems[i].id] = payloadBody

        payload.push({
          leadId: selectedItems[i].id,
          ...payloadBody,
        })
      }
      const myInit = { body: payload }
      promises.push(API.put('mav-outlook-api', '/bulk/leads', myInit))
    }
    search?.updateProspectsData(dataToUpdate)
    await excutePromises(promises)
    setIsLoading(false)
  }

  const updateSelectedLeads = async (): Promise<void> => {
    setIsLoading(true)
    const data: any = await getLeadsDataToUpdate()

    const promises: any = []
    const dataToUpdate = {}

    data?.map(item => {
      dataToUpdate[item?.id] = {}
      const payload: any = {
        leadId: item?.id,
      }

      if (currentAction === 'hot') {
        payload.isHot = !item?.isHot
        dataToUpdate[item?.id].isHot = !item?.isHot
      }

      if (currentAction === 'deactivate') {
        payload.deactivate = true
        dataToUpdate[item?.id].deactivate = true
      }

      if (currentAction === 'marketing') {
        payload.sendToMarketing = true
        dataToUpdate[item?.id].sendToMarketing = true
        dataToUpdate[item?.id].status = 'Sent To Marketing'
      }

      if (currentAction === 'engaged') {
        payload.dnc = true
        dataToUpdate[item?.id].dnc = true
        dataToUpdate[item?.id].status = 'DO NOT CONTACT'
      }

      if (openAssignRank !== '') {
        const rankToBeSaved = openAssignRank
        payload.rank = rankToBeSaved
        dataToUpdate[item?.id].rank = rankToBeSaved
      }

      const myInit = { body: payload }

      const endPoint = `/leads/${item?.email}`
      const api = 'mav-outlook-api'

      if (currentAction === 'delete') {
        dataToUpdate[item?.id].delete = true
        promises.push(API.del(api, endPoint, {}))
      } else {
        promises.push(API.put(api, endPoint, myInit))
      }
    })

    if (currentAction === 'delete') {
      search?.deleteLeads(dataToUpdate)
    } else {
      search?.updateProspectsData(dataToUpdate)
    }

    await excutePromises(promises)
    setIsLoading(false)
  }

  const handleUpdateCurrentAction = action => {
    setCurrentAction(action)
    cleanManeuver()
  }

  const onActionClick = async () => {
    if (openAssignManeuver !== '') {
      await onAssignManeuver()
    } else {
      await updateSelectedLeads()
    }
    setOpenActions(false)
    setCurrentAction('')
  }

  useEffect(() => {
    prospects?.getMasters()
  }, [])

  useEffect(() => {
    const tempList = [
      {
        name: 'Rev-Up',
        missions: _.keys(prospects?.masters?.firstTouch)
          .sort()
          .map(mission => {
            return {
              name: [mission.slice(0, mission.length - 1), '#', mission.slice(-1)].join(''),
            }
          }),
      },
      {
        name: 'Engaged',
        missions: _.keys(prospects?.masters?.followUp)
          .sort()
          .map(mission => {
            return {
              name: [mission.slice(0, mission.length - 1), '#', mission.slice(-1)].join(''),
            }
          }),
      },
      {
        name: 'Re-Engage',
        missions: _.keys(prospects?.masters?.nurture)
          .sort()
          .map(mission => {
            return {
              name: [mission.slice(0, mission.length - 1), '#', mission.slice(-1)].join(''),
            }
          }),
      },
    ]
    setManeuverList(tempList)
  }, [prospects?.masters])

  return (
    <Draggable defaultPosition={position}>
      <Paper className="action-popup">
        <MenuList
          autoFocusItem={openActions}
          id="menu-list-action"
          //   onKeyDown={handleListKeyDown}
          style={{ padding: 0 }}
        >
          <div className="header-border" />
          <div className="actions-header">
            <p className="popup-menu-header">BULK CONTACT ACTIONS</p>
            <FaTimes className="bulk-contact-close" onClick={handleActionsClose} />
          </div>
          <ListItem
            onClick={() => handleUpdateCurrentAction('hot')}
            className={`icon-menu ${currentAction === 'hot' ? 'active' : ''}`}
          >
            <ListItemIcon>
              <FaHotjar />
            </ListItemIcon>
            <ListItemText>HOT!</ListItemText>
          </ListItem>

          <ListItem button onClick={handleClickAssign} className="icon-menu">
            <ListItemIcon>
              <FaTelegramPlane />
            </ListItemIcon>
            <ListItemText>Assign to Maneuver</ListItemText>
            {openAssign ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openAssign} timeout="auto" unmountOnExit>
            {maneuverList?.map(maneuver => (
              <List component="div" disablePadding key={`${maneuver.name}`}>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={(): void => handleClickAssignManeuver(maneuver.name)}
                >
                  <ListItemIcon>
                    {openAssignManeuver === maneuver.name ? (
                      <FaCheckCircle className="check_icon" />
                    ) : (
                      <FaRegCircle />
                    )}
                  </ListItemIcon>
                  <ListItemText primary={maneuver.name} />
                  {openAssignManeuver === maneuver.name ? <ExpandLess /> : <ExpandMore />}
                </ListItem>
                <Collapse in={openAssignManeuver === maneuver.name} timeout="auto" unmountOnExit>
                  {maneuver.missions.map(mission => (
                    <List component="div" disablePadding key={`${maneuver.name}-${mission.name}`}>
                      <ListItem
                        button
                        className={classes.nestedSecondLevel}
                        onClick={(): void => handleClickAssignMission(mission.name)}
                      >
                        <ListItemIcon>
                          {openAssignManeuver === maneuver.name &&
                          openAssignMission === mission.name ? (
                            <FaCheckCircle className="check_icon" />
                          ) : (
                            <FaRegCircle />
                          )}
                        </ListItemIcon>
                        <ListItemText primary={mission.name} />
                      </ListItem>
                    </List>
                  ))}
                </Collapse>
              </List>
            ))}
            <Form.Group controlId="start-date" className="mt-3 date-container">
              <Form.Label>Start Date</Form.Label>
              <Form.Control
                as={DatePicker}
                name="start_date"
                minDate={new Date()}
                required
                defaultValue={moment(new Date()).format('YYYY-MM-DD')}
                value={startDate}
                filterDate={isWeekday}
                onChange={handleStartDateChange}
                onSelect={(value: Date): void => {
                  value.setHours(23, 59, 59)
                  handleStartDateChange(value)
                }}
              />
            </Form.Group>
          </Collapse>

          <ListItem button onClick={handleClickRank} className="icon-menu">
            <ListItemIcon>
              <FaBullseye />
            </ListItemIcon>
            <ListItemText>Rank</ListItemText>
            {openRank ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openRank} timeout="auto" unmountOnExit>
            {ranks.map(rank => (
              <List component="div" disablePadding key={`${rank}`}>
                <ListItem
                  button
                  className={classes.nested}
                  onClick={(): void => handleClickAssignRank(rank)}
                >
                  <ListItemIcon>
                    {openAssignRank === rank ? (
                      <FaCheckCircle className="check_icon" />
                    ) : (
                      <FaRegCircle />
                    )}
                  </ListItemIcon>
                  <ListItemText primary={rank} />
                </ListItem>
              </List>
            ))}
          </Collapse>

          <ListItem
            onClick={() => handleUpdateCurrentAction('marketing')}
            className={`icon-menu ${currentAction === 'marketing' ? 'active' : ''}`}
          >
            <ListItemIcon>
              <FaBullhorn />
            </ListItemIcon>
            <ListItemText>Send to Marketing</ListItemText>
          </ListItem>

          <ListItem
            onClick={() => handleUpdateCurrentAction('engaged')}
            className={`icon-menu ${currentAction === 'engaged' ? 'active' : ''}`}
          >
            <ListItemIcon>
              <FaUserSlash />
            </ListItemIcon>
            <ListItemText>Do Not Engage</ListItemText>
          </ListItem>

          <ListItem
            onClick={() => handleUpdateCurrentAction('delete')}
            className={`icon-menu icon-menu-delete ${currentAction === 'delete' ? 'active' : ''}`}
          >
            <ListItemIcon>
              <FaTrashAlt />
            </ListItemIcon>
            <ListItemText>Delete</ListItemText>
          </ListItem>

          <ListItem
            onClick={() => handleUpdateCurrentAction('deactivate')}
            className={`icon-menu ${currentAction === 'deactivate' ? 'active' : ''}`}
          >
            <ListItemIcon>
              <FaBellSlash />
            </ListItemIcon>
            <ListItemText>Deactivate</ListItemText>
          </ListItem>

          {currentAction === 'delete' && (
            <div className="delete-form">
              <ListItemText>Are you sure you want to delete those contacts?</ListItemText>
              <div className="delete-type-container">
                <Divider />
                <div className="delete-type">
                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={(): void => {}}
                    className="delete-type-item"
                    onClick={() => handleDeleteTypeChange('Affirmative')}
                  >
                    {deleteType === 'Affirmative' ? (
                      <FaCheckCircle className="check_icon" />
                    ) : (
                      <FaRegCircle />
                    )}
                    Affirmative
                  </div>
                  <div
                    role="button"
                    tabIndex={0}
                    onKeyDown={(): void => {}}
                    className="delete-type-item"
                    onClick={() => handleDeleteTypeChange('Negative')}
                  >
                    {deleteType === 'Negative' ? (
                      <FaCheckCircle className="check_icon" />
                    ) : (
                      <FaRegCircle />
                    )}
                    Negative
                  </div>
                </div>
                <Divider />
              </div>
              <BootBtn
                variant="danger"
                block
                onClick={(): void => {
                  onActionClick()
                }}
              >
                DELETE FROM MY HANGAR
              </BootBtn>
            </div>
          )}

          {((openAssignManeuver !== '' && openAssignMission !== '') ||
            currentAction === 'hot' ||
            currentAction === 'engaged' ||
            currentAction === 'marketing' ||
            currentAction === 'deactivate' ||
            openAssignRank !== '') && (
            <BootBtn
              variant="primary"
              block
              onClick={(): void => {
                onActionClick()
              }}
            >
              <span style={{ paddingRight: 10 }}>APPLY</span>
              {isLoading ? <CircularProgress size={18} /> : null}
            </BootBtn>
          )}
        </MenuList>
      </Paper>
    </Draggable>
  )
}

export default inject('search', 'prospects')(withRouter(observer(BulkLeadActions)))
